import * as React from "react";

export default () => {
  return <div>Ange hur uppsägningen ska genomföras samt övriga detaljer.</div>;
};
